/* MinhandBros size guide: the piece drawn to scale above an 84" sofa, next to a 5'5" person (1 unit = 1 cm).
   Used by assets/mb-pdp.js when the size guide opens; loaded by snippets/mb-pdp.liquid on products with size data.
   Shapes w and d (width or diameter only, snippets/mb-pdp-gen.liquid, 2026-11): the height is unknown, so only the width is drawn. */
(function () {
  if (window.MBPDraw) return;
  var mbp = function () { return window.MBP || {}; };
  var PAL = {
    terracotta: ['#c0603b', '#c9a27e', '#e6d6bb'], green: ['#6f7d55', '#a3ae8f', '#ebe3d2'],
    blue: ['#2f5876', '#c9bfae', '#ebe3d2'], grey: ['#4b4e54', '#a2a2a0', '#ebe3d2'],
    navy: ['#26344b', '#a3ae8f', '#efe8da'], latte: ['#b08a5a', '#2c4a6b', '#ebe3d2'], black: ['#2e2e2e', '#6b6b6b', '#d9d2c4'],
    other: ['#b8916b', '#d9c6a5', '#ebe3d2']
  };
  function palette() {
    var MBP = mbp();
    var opt = MBP.styleOption ? MBP.styleOption() : null, chosen = opt && opt.querySelector('input:checked');
    var key = ((chosen && chosen.value) || MBP.style || '').toLowerCase().split(' ')[0];
    return PAL[key] || PAL.other;
  }
  var f = function (n) { return n.toFixed(1); };
  function loops(yc, x0, y0, W, H, t, p, sets) {
    var s = '', sw = Math.max(1, W / 66);
    sets.forEach(function (L) {
      for (var i = 0; i < L.colors.length; i++) {
        var a = L.u1 + i * 0.014, b = L.u2 - i * 0.014;
        var xa = x0 + a * W, xb = x0 + b * W, ya = yc(a) + t / 2 - 1, yb2 = yc(b) + t / 2 - 1;
        var bottom = y0 + L.depth * H - i * 0.032 * H;
        var c = (bottom - 0.25 * (ya + yb2) / 2) / 0.75;
        s += '<path d="M' + f(xa) + ',' + f(ya) + ' C' + f(xa) + ',' + f(c) + ' ' + f(xb) + ',' + f(c) + ' ' + f(xb) + ',' + f(yb2) + '" fill="none" stroke="' + p[L.colors[i]] + '" stroke-width="' + f(sw) + '"/>';
      }
    });
    return s;
  }
  function waveBar(x0, y0, W, H) {
    var yc = function (u) { return y0 + 0.11 * H - 0.06 * H * Math.sin(2 * Math.PI * (u - 0.05)); };
    var t = Math.max(4, Math.min(9, 0.085 * H)), top = [], bot = [];
    for (var i = 0; i <= 30; i++) { var u = i / 30; top.push(f(x0 + u * W) + ',' + f(yc(u) - t / 2)); bot.unshift(f(x0 + u * W) + ',' + f(yc(u) + t / 2)); }
    return { yc: yc, t: t, svg: '<polygon points="' + top.concat(bot).join(' ') + '" fill="#5b3a29"/>' };
  }
  function piece(x0, y0, W, H, p) {
    var MBP = mbp(), s = '', i, n, u, x;
    if (MBP.shape === 'wave') {
      // V93: wavy walnut bar and two U-shaped cord loops
      var wb = waveBar(x0, y0, W, H);
      s += loops(wb.yc, x0, y0, W, H, wb.t, p, [
        { u1: 0.33, u2: 0.97, depth: 0.8, colors: [0, 0, 0, 0, 2, 2, 1, 1, 2, 2] },
        { u1: 0.03, u2: 0.67, depth: 1.0, colors: [2, 2, 2, 2, 1, 1, 0, 0, 0, 2] }
      ]);
      return s + wb.svg;
    }
    if (MBP.shape === 'wavetassel') {
      // U44: wavy walnut bar with beaded tassels, light to dark from left to right
      var wt = waveBar(x0, y0, W, H);
      n = Math.max(10, Math.round(W / 6));
      for (i = 0; i < n; i++) {
        u = (i + 0.5) / n; x = x0 + u * W;
        var ty = wt.yc(u) + wt.t / 2, bottom = y0 + H * (0.72 + 0.28 * ((i * 7) % 5) / 4), tt = ty + 0.3 * (bottom - ty);
        s += '<line x1="' + f(x) + '" y1="' + f(ty) + '" x2="' + f(x) + '" y2="' + f(tt) + '" stroke="#e9e0cc" stroke-width=".7"/>';
        s += '<circle cx="' + f(x) + '" cy="' + f(tt - 2) + '" r="1.3" fill="#dcc79f"/>';
        s += '<rect x="' + f(x - 1.6) + '" y="' + f(tt) + '" width="3.2" height="' + f(bottom - tt) + '" rx="1" fill="' + p[u < 0.34 ? 2 : u < 0.67 ? 1 : 0] + '"/>';
      }
      return s + wt.svg;
    }
    if (MBP.shape === 'wavefringe') {
      // U08: wavy walnut bar with straight cord fringe in color bands
      var wf = waveBar(x0, y0, W, H);
      n = Math.max(14, Math.round(W / 3.5));
      for (i = 0; i < n; i++) {
        u = (i + 0.5) / n; x = x0 + u * W;
        var ft = wf.yc(u) + wf.t / 2;
        s += '<line x1="' + f(x) + '" y1="' + f(ft) + '" x2="' + f(x) + '" y2="' + f(ft + 0.8 * H) + '" stroke="' + p[u < 0.25 ? 2 : u < 0.5 ? 1 : 0] + '" stroke-width="' + f(Math.max(1.2, W / 55)) + '"/>';
      }
      return s + wf.svg;
    }
    if (MBP.shape === 'round') {
      // V07: round piece, wooden top half and cord fringe below
      var r = W / 2, cx = x0 + r, cy = y0 + r;
      n = Math.max(16, Math.round(W / 2.2));
      for (i = 0; i < n; i++) {
        u = (i + 0.5) / n; x = x0 + u * W;
        var dx = x - cx, len = Math.sqrt(Math.max(0, r * r - dx * dx)) * (1.02 + 0.04 * (i % 3));
        s += '<line x1="' + f(x) + '" y1="' + f(cy) + '" x2="' + f(x) + '" y2="' + f(cy + len) + '" stroke="' + p[u < 0.2 || u > 0.8 ? 2 : u < 0.4 || u > 0.6 ? 1 : 0] + '" stroke-width="' + f(Math.max(1, W / 60)) + '"/>';
      }
      return s + '<path d="M' + f(x0) + ',' + f(cy) + ' A' + f(r) + ',' + f(r) + ' 0 0 1 ' + f(x0 + W) + ',' + f(cy) + ' Z" fill="#5b3a29"/>';
    }
    var bar = 5;
    if (MBP.shape === 'fringe') {
      // V97, V29: straight bar with cord fringe, longest in the middle, light to dark from left to right
      n = Math.max(14, Math.round(W / 3.5));
      for (i = 0; i < n; i++) {
        u = (i + 0.5) / n; x = x0 + u * W;
        var lb = y0 + H * (0.74 + 0.26 * Math.sin(Math.PI * u));
        s += '<line x1="' + f(x) + '" y1="' + f(y0 + bar) + '" x2="' + f(x) + '" y2="' + f(lb) + '" stroke="' + p[u < 0.34 ? 2 : u < 0.67 ? 1 : 0] + '" stroke-width="' + f(Math.max(1.2, W / 55)) + '"/>';
      }
    } else if (MBP.shape === 'arc') {
      // V91, V28, V16, V34: straight walnut bar and two crossing cord loops
      var flat = function () { return y0 + bar / 2; };
      s += loops(flat, x0, y0, W, H, bar, p, [
        { u1: 0.02, u2: 0.62, depth: 1.0, colors: [2, 2, 2, 2, 0, 0, 0, 1, 1, 0] },
        { u1: 0.38, u2: 0.98, depth: 0.86, colors: [2, 2, 2, 0, 0, 0, 1, 1, 0, 2] }
      ]);
    } else if (MBP.shape === 'swag') {
      // V58: straight walnut bar and one wide U of cords
      var flat2 = function () { return y0 + bar / 2; };
      s += loops(flat2, x0, y0, W, H, bar, p, [{ u1: 0.03, u2: 0.97, depth: 1.0, colors: [2, 2, 1, 1, 0, 0, 1, 1, 2, 2] }]);
    } else if (MBP.shape === 'beads') {
      // V55: straight bar, cords with two waves of wood beads, tassels along a wave
      n = Math.max(12, Math.round(W / 4.5));
      var wave = function (u, ph) { return 0.5 - 0.5 * Math.cos(2 * Math.PI * (1.25 * u + ph)); };
      for (i = 0; i < n; i++) {
        var uu = (i + 0.5) / n, bottom = y0 + H - 0.22 * H * wave(uu, 0), th = 0.2 * H, tt = bottom - th;
        x = x0 + uu * W;
        s += '<line x1="' + f(x) + '" y1="' + f(y0 + bar) + '" x2="' + f(x) + '" y2="' + f(tt) + '" stroke="#e9e0cc" stroke-width=".7"/>';
        s += '<circle cx="' + f(x) + '" cy="' + f(y0 + 0.26 * H + 0.12 * H * wave(uu, 0.1)) + '" r="1.3" fill="#dcc79f"/>';
        s += '<circle cx="' + f(x) + '" cy="' + f(tt - 3) + '" r="1.3" fill="#dcc79f"/>';
        s += '<rect x="' + f(x - 1.4) + '" y="' + f(tt) + '" width="2.8" height="' + f(th) + '" rx="1" fill="' + p[i % 3] + '"/>';
      }
    } else {
      return '';
    }
    return s + '<rect x="' + f(x0 - 2) + '" y="' + f(y0) + '" width="' + f(W + 4) + '" height="' + bar + '" rx="1" fill="#5b3a29"/>';
  }
  function scene(sz) {
    var art = mbp().shape;
    if (!/^(wave|wavetassel|wavefringe|round|fringe|arc|swag|beads|w|d)$/.test(art)) return '';
    var line = art === 'w' || art === 'd';
    var floor = 292, sofaW = 213, sofaX = 112, sofaTop = floor - 85, W = sz.wcm, H = line ? 0 : sz.hcm, cx = sofaX + sofaW / 2;
    var label = sz.win + (art === 'round' || art === 'd' ? ' across' : ' wide') + ' (' + sz.wcm + ' cm)';
    var ax = cx - W / 2, ay = sofaTop - 22 - H, dy = ay - 9, g = '';
    g += '<rect x="0" y="0" width="340" height="' + floor + '" fill="#f3eee4"/><rect x="0" y="' + floor + '" width="340" height="8" fill="#d8cfbf"/>';
    g += '<circle cx="52" cy="' + (floor - 154) + '" r="11" fill="#cbc4b6"/><path d="M38 ' + (floor - 140) + ' q14 -6 28 0 l4 62 h-8 l-2 76 h-7 l-1 -60 h-1 l-1 60 h-7 l-2 -76 h-8z" fill="#cbc4b6"/>';
    g += '<text x="52" y="' + (floor - 172) + '" font-size="11" text-anchor="middle" fill="#7a7466">5\'5" person</text>';
    g += '<rect x="' + (sofaX + 8) + '" y="' + sofaTop + '" width="' + (sofaW - 16) + '" height="44" rx="12" fill="#c9c3b3"/>';
    g += '<rect x="' + sofaX + '" y="' + (sofaTop + 16) + '" width="24" height="56" rx="10" fill="#bdb6a5"/><rect x="' + (sofaX + sofaW - 24) + '" y="' + (sofaTop + 16) + '" width="24" height="56" rx="10" fill="#bdb6a5"/>';
    g += '<rect x="' + (sofaX + 20) + '" y="' + (sofaTop + 36) + '" width="' + (sofaW - 40) + '" height="34" rx="8" fill="#d6d0c2"/>';
    g += '<rect x="' + (sofaX + 14) + '" y="' + (floor - 14) + '" width="6" height="14" fill="#8a7a64"/><rect x="' + (sofaX + sofaW - 20) + '" y="' + (floor - 14) + '" width="6" height="14" fill="#8a7a64"/>';
    g += '<text x="' + cx + '" y="' + (floor - 30) + '" font-size="11" text-anchor="middle" fill="#6d675a">84" sofa</text>';
    if (line) {
      // Width only: a bar as wide as the piece, end marks, the label above it.
      g += '<rect x="' + f(ax) + '" y="' + (dy - 3) + '" width="' + f(W) + '" height="6" rx="3" fill="' + palette()[0] + '"/>';
      g += '<line x1="' + f(ax) + '" y1="' + (dy - 9) + '" x2="' + f(ax) + '" y2="' + (dy + 9) + '" stroke="#444"/><line x1="' + f(ax + W) + '" y1="' + (dy - 9) + '" x2="' + f(ax + W) + '" y2="' + (dy + 9) + '" stroke="#444"/>';
      g += '<text x="' + cx + '" y="' + (dy - 15) + '" font-size="12" font-weight="700" text-anchor="middle" fill="#2f2f2f">' + label.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</text>';
    } else {
      g += piece(ax, ay, W, H, palette());
      g += '<line x1="' + ax + '" y1="' + dy + '" x2="' + (ax + W) + '" y2="' + dy + '" stroke="#444" stroke-width="1"/><line x1="' + ax + '" y1="' + (dy - 4) + '" x2="' + ax + '" y2="' + (dy + 4) + '" stroke="#444"/><line x1="' + (ax + W) + '" y1="' + (dy - 4) + '" x2="' + (ax + W) + '" y2="' + (dy + 4) + '" stroke="#444"/>';
      g += '<rect x="' + (cx - 56) + '" y="' + (dy - 9) + '" width="112" height="17" fill="#f3eee4"/><text x="' + cx + '" y="' + (dy + 4) + '" font-size="12" font-weight="700" text-anchor="middle" fill="#2f2f2f">' + label.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</text>';
    }
    return '<svg viewBox="0 0 340 300" width="100%" role="img" aria-label="' + label.replace(/"/g, '&quot;') + ', drawn above an 84 inch sofa" style="display:block;border-radius:10px">' + g + '</svg>';
  }
  window.MBPDraw = { scene: scene };
})()